import axios from "axios";

interface EdmsResponse {
  statusCode: number,
  message: string
}

function isEdmsResponse(payload: unknown): payload is EdmsResponse {
  return (
    typeof payload === 'object' &&
    payload !== null &&
    'statusCode' in payload &&
    typeof payload.statusCode === 'number' &&
    'message' in payload &&
    typeof payload.message === 'string'
  );
};

export const failedWithStatusCode = (error: unknown, statusCode: number): boolean => {
  if (axios.isAxiosError(error) && error.response?.status === 409 && isEdmsResponse(error.response?.data)) {
    const edmsResponse: EdmsResponse = error.response.data;
    return edmsResponse.statusCode === statusCode;
  }

  return axios.isAxiosError(error) && error.response?.status === statusCode;
};